import router from './router'
import store from './store'
import NProgress from 'nprogress'
import { getToken, modulePath } from '@/utils/auth'
import { flatMap } from 'lodash'
const whiteList = ['/login', '/auth-redirect', '/autoLogin'] // no redirect whitelist
const publicList = [
  '/',
  '/home',
  '/404',
  '/notice',
  '/base_info',
  '/change_password',
  '/feedback_results',
  '/autoLogin'
] // 公共模块

/**
 * 动态注册路由列表
 * @param {Object} router 路由
 * @param {Array} modules 模块列表
 * @param {Object} to 到达路由
 * @param {Function} next 跳转方法
 */
function registerRouter(router, modules, to, next, replace) {
  store.dispatch('GenerateRoutes', { modules: modules, route: to }).then(
    () => {
      // 根据menus生成可访问的路由表
      const key = modulePath(to)
      if (store.getters.addRouters && store.getters.addRouters[key]) {
        router.addRoutes(store.getters.addRouters[key].routers) // 动态添加可访问路由表
        next({ ...to, replace: replace }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      } else {
        next('/home')
      }
    },
    () => {
      // console.error(err)
      next('/home')
    }
  )
}
/**
 * 处理越权跳转页面限制方法
 * @param {Object} to 路由跳转去向信息
 * @param {Object} next 路由跳转实例
 * @param {Array} mergedValues 路由数据集合
 */
function verifyPagePermission(to, next, mergedValues, bl = false) {
  if (mergedValues.length) {
    const toPath = to.path.split('/')
    if (toPath.length > 1) {
      let toPathStr = `/${toPath[1]}`
      if (bl) { // 1.0 模块单独处理
        toPathStr = to.query.url
      }
      const findVal = mergedValues.find((e) => (e.funcUrl === toPathStr || e.funcUrl === to.path || e.funcUrl.indexOf(toPathStr) !== -1))
      if (!(findVal && (findVal && findVal.status) === 1)) {
        window.location.href = '/home'
        return true
      }
    }
  }
}

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) {
    // determine if there has token
    /* has token*/

    if (to.path === '/login' && to.query.service) {
      // 兼容智库系统 即使登录了也不能进到iways系统
      next()
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      if (store.getters.modules.length === 0) {
        // 判断当前用户是否已拉取完路由信息
        store
          .dispatch('GetModules', { router })
          .then(data => {
            if (publicList.indexOf(to.path) !== -1) {
              // 在免注册名单，直接进入
              next()
            } else {
              // 注册路由并进入
              registerRouter(router, data, to, next, true)
            }
            // 1.0的模块越权页面判断条件提供
            let urlBl = false
            const urlStr = to.query.url
            if (urlStr) {
              const strArr = urlStr.split(':')
              if (strArr.length > 1) {
                if (strArr[1].indexOf('//car.waysdata.com') > -1) {
                  urlBl = true
                }
              }
            }
            // 过滤白名单不需要进行越权跳转页面限制
            if (![...whiteList, ...publicList, '/frame'].includes(to.path) || urlBl) {
              const findArr = data.find(e => e.groupId === 1) // 过滤出智库的菜单数据
              const branches = findArr.branches
              const branches2 = flatMap(branches, 'branches')
              let mergedValues = flatMap(branches, 'funcTreeNodes')
              if (branches2.length) {
                const mergedValues2 = flatMap(branches2, 'funcTreeNodes')
                mergedValues = [...mergedValues, ...mergedValues2]
              }
              store.commit('SET_FUNCTREE_NODES_ARR', mergedValues)
              verifyPagePermission(to, next, mergedValues, urlBl)
            }
          })
          .catch(err => {
            store.dispatch('FedLogOut').then(() => {
              console.error(err)
              next({ path: '/' })
            })
          })
      } else {
        if (publicList.indexOf(to.path) !== -1) {
          // 在免注册名单，直接进入
          next()
        } else {
          const key = modulePath(to)
          if (!store.getters.addRouters[key]) {
            // 注册路由并进入
            registerRouter(router, store.getters.modules, to, next, false)
          } else {
            // 过滤白名单不需要进行越权跳转页面限制
            if (![...whiteList, ...publicList, '/frame'].includes(to.path)) {
              if (!verifyPagePermission(to, next, store.state.user.funcTreeNodesArr)) next()
            } else {
              next()
            }
          }
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 前端 允许 在线报告 重定向
      const redirect = router.history.pending.fullPath
      const query =
        redirect.indexOf('/report/preview') >= 0
          ? `?redirect=${decodeURIComponent(redirect)}`
          : ''

      next(`/login${query}`) // 否则全部重定向到登录页
      // window.location.href = `/login`
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/asyncRouter.js